<script>
import SelectorAccessoriesCard from "./SelectorAccessoriesCard.vue";
import FundingDetailsLink from "../common/FundingDetailsLink.vue";
import PxfCb4xModal from "../common/components/PxfCb4xModal.vue";
import Cb4xModalContent from "../common/components/Cb4xModalContent.vue";
import PxfModalContent from "../common/components/PxfModalContent.vue";
import PayingDetailCb4xModalContent from "../common/components/PayingDetailCb4xModalContent.vue";
import DasTooltip from "../common/DasTooltip.vue";

export default {
    components: {
        DasTooltip,
        PayingDetailCb4xModalContent, PxfModalContent, Cb4xModalContent, PxfCb4xModal,
        FundingDetailsLink,
        SelectorAccessoriesCard
    },
    props: {
        showAccessorySpinner: {
            type: Boolean,
            default: false
        },
        accessories: {
            type: Array,
            required: true
        },
        showAccessoryBloc: {
            type: Boolean,
            default: false
        },
        showMoreAccessoriesButton: {
            type: Boolean,
            default: false
        },
        wordingButtonMoreAccessories: {
            type: String,
            required: true
        },
        listLimit: {
            type: Number,
            required: true
        },
        filters: {
            type: Array,
            required: true
        },
        sort: {
            type: String,
            required: true
        },
        fundingDetailsDto: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            widgetAmount: undefined,
            fundingDetailsSeoId: ''
        }
    },
    computed: {
        selectedFundingDetailVersion() {
            return this.accessories.find(accessory => accessory.versions[0].idSeo.value === this.fundingDetailsSeoId)?.versions[0];
        }
    },
    mounted() {
        // Mise à jour des hauteurs des tuiles
        window.addEventListener("resize", () => {
            this.updateLayout();
        });
    },
    updated() {
        this.$nextTick(function () {
            this.updateLayout();
        })
    },
    methods: {
        showFundingDetailsLink: function (accessory) {
            return accessory.versions[0].hasInstallmentPlan;
        },
        showDasTooltip: function (accessory) {
            return accessory.dasAccessible;
        },
        loadAccessory: function (accessory) {
            const accessoryIdSeo = (accessory.versions !== null && accessory.versions.length > 0) ? accessory.versions[0].idSeo.value : null
            if (accessoryIdSeo) {
                let url = window.location.href;
                if (getParameterByName('seoId', url)) {
                    url = setParam(url, 'seoId', accessoryIdSeo);
                } else {
                    url = addParam(url, 'seoId=' + accessoryIdSeo)
                }
                window.history.replaceState(null, '', url);//passage de l'idSeo dans l'url pour pouvoir forcer le scroll au retour sur le selecteur
            }
            window.location.href = accessory.accessoryUrl
        },
        fetchMoreAccessories: function () {
            this.showAccessoryBloc = true;
            const pageIndex = Math.floor(this.accessories.length / this.listLimit) + 1
            let url = window.location.href
            if (getParameterByName('page', url)) {
                url = setParam(url, 'page', pageIndex)
            } else {
                url = addParam(url, 'page=' + pageIndex)
            }
            window.history.replaceState(null, '', url)
            const data = {
                seoIds: this.filters,
                from: this.accessories.length,
                to: this.accessories.length + this.listLimit,
                sort: this.sort
            };
            this.$emit("fetch-accessories", data);
        },
        handleFundingDetailsClick(versionSeoId) {
            this.fundingDetailsSeoId = versionSeoId;
            this.$nextTick(() => {
                this.showFundingPopin();
            });
        },
        showFundingPopin() {
            const popin = $("#funding-details-popin");
            if (popin) {
                popin.modal("show");
            }
        },
        updateLayout() {
            //nombre de tuiles par ligne selon le media (mobile, tablette et desktop)
            let nbOfTilesPerRow = 1
            if (window.matchMedia("(min-width: " + myshop.ob1.breakpoints.xl + "px)").matches) {
                nbOfTilesPerRow = 3
            } else if (window.matchMedia("(min-width: " + myshop.ob1.breakpoints.md + "px)").matches) {
                nbOfTilesPerRow = 2
            }

            this.alignCardItemsVertically(".selector-accessory-card .infos-accessory", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-accessory-card .infos-price", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-accessory-card .infos-advantage", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-accessory-card .payment-solutions-details", nbOfTilesPerRow);
        },
        alignCardItemsVertically(selector, nbOfTilesPerRow) {
            let listElements = document.querySelectorAll(selector);
            if (listElements.length > 0) {
                for (let row = 0; row < listElements.length; row += nbOfTilesPerRow) {
                    let tmp = [];
                    tmp.push(Array.from(listElements).slice(row, row + nbOfTilesPerRow));
                    let elements = tmp.flat()
                    if (elements.length > 0) {
                        this.alignItemsVertically(elements, nbOfTilesPerRow)
                    }
                }
            }
        },
        getMaximumHeight(list) {
            const heights = Array.from(list)
                .map(elt => $(elt).height());
            return Math.max(...heights);
        },
        alignItemsVertically(list, nbOfTilesPerRow) {
            Array.from(list).forEach(elt => {
                elt.style.removeProperty("height")
            });
            //Pas de mise à jour de hauteur de ligne pour media mobile
            if (nbOfTilesPerRow > 1) {
                const maxHeight = this.getMaximumHeight(list);
                if (maxHeight === 0) {
                    return;
                }
                Array.from(list).forEach(elt => {
                    $(elt).height(maxHeight)
                });
            }
        }
    }
}
</script>

<template>
    <div id="accessoriesDisplay">
        <div v-if="showAccessoryBloc" class="row">
            <article
                v-for="(accessory, index) in accessories"
                :key="index"
                class="col-12 col-md-6 col-xl-4 selector-accessory-card mb-1 d-flex flex-column"
            >
                <selector-accessories-card
                    :id="accessory.versions[0].idSeo.value"
                    :accessory="accessory"
                    class="pt-2 px-1"
                    @ob1-cards-click="loadAccessory(accessory)"
                />
                <div
                    v-if="showDasTooltip(accessory) || showFundingDetailsLink(accessory)"
                    class="d-flex payment-solutions-details"
                >
                    <das-tooltip
                        v-if="showDasTooltip(accessory)"
                        :id="'tooltip-accessory' + index"
                        :das="accessory.dasAccessible"
                    />
                    <FundingDetailsLink
                        v-if="showFundingDetailsLink(accessory)"
                        class="ms-auto"
                        :seo-id="accessory.versions[0].idSeo.value"
                        :text="fundingDetailsDto.linkText"
                        @fundingDetailsClick="handleFundingDetailsClick"
                    />
                </div>
                <div v-else class="mb-1" />
            </article>
        </div>
        <div v-if="showAccessorySpinner" class="d-flex justify-content-center">
            <ob1-progress-indicators type="undetermined" :size="50" />
        </div>
        <div class="d-flex justify-content-center my-2">
            <button
                v-if="showMoreAccessoriesButton"
                id="showMoreButton"
                class="btn btn-secondary mx-0"
                :disabled="showAccessorySpinner"
                @click="fetchMoreAccessories()"
            >
                {{ wordingButtonMoreAccessories }}
            </button>
        </div>
        <!-- Popin de financement-->
        <pxf-cb4x-modal
            v-if="selectedFundingDetailVersion"
            modal-id="funding-details-popin"
            :display-cb4x="selectedFundingDetailVersion.isCb4xAvailable"
            :display-pxf="selectedFundingDetailVersion.isPxfAvailable"
        >
            <template v-if="selectedFundingDetailVersion.isCb4xAvailable" #cb4x-content>
                <!-- 4xCB payant  -->
                <paying-detail-cb4x-modal-content
                    v-if="fundingDetailsDto.cb4xPopin.withFees"
                    modal-id="funding-details-popin"
                    :oney-merchant-guid="fundingDetailsDto.cb4xPopin.oneyMerchantGuid"
                    :oney-widget-src="fundingDetailsDto.oneyWidgetSrc"
                    :counter-delay="fundingDetailsDto.counterDelay"
                    :amount="selectedFundingDetailVersion.discountedPriceInCents / 100"
                    :header-block="fundingDetailsDto.cb4xPopin.headerBlock"
                    :how-to-benefit="fundingDetailsDto.cb4xPopin.howToBenefit"
                    :cgu="fundingDetailsDto.cb4xPopin.cgu"
                    :illustration="fundingDetailsDto.cb4xPopin.imageZen"
                />
                <!-- 4xCB gratuit avec détail du prix  -->
                <cb4x-modal-content
                    v-else-if="selectedFundingDetailVersion.spreadingPrice4xCbWithoutFees"
                    :header-block="fundingDetailsDto.cb4xPopin.headerBlock"
                    :payment-block="fundingDetailsDto.cb4xPopin.paymentBlock"
                    :payment-simulation-block="fundingDetailsDto.cb4xPopin.paymentSimulationBlock"
                    :how-to-benefit="fundingDetailsDto.cb4xPopin.howToBenefit"
                    :faq="fundingDetailsDto.cb4xPopin.faqBlock"
                    :cgu="fundingDetailsDto.cb4xPopin.cgu"
                    :monthly-price="selectedFundingDetailVersion.spreadingPrice4xCbWithoutFees.monthlyPrice"
                    :first-monthly-price="selectedFundingDetailVersion.spreadingPrice4xCbWithoutFees.firstMonthlyPrice"
                    :one-shot-price="selectedFundingDetailVersion.spreadingPrice4xCbWithoutFees.oneShotPrice"
                    :illustration="fundingDetailsDto.cb4xPopin.imageZen"
                />
            </template>
            <!-- Payez en 12x, 24x, 36x ou 48x  -->
            <template v-if="selectedFundingDetailVersion.isPxfAvailable" #pxf-content>
                <pxf-modal-content
                    :header-block-dto="fundingDetailsDto.pxfPopin.headerBlockDto"
                    :example-pxf-data="fundingDetailsDto.pxfPopin.examplePxfData"
                    :example-pxf-tab-subtitle="fundingDetailsDto.pxfPopin.examplePxfTabSubtitle"
                    :example-pxf-tab-title="fundingDetailsDto.pxfPopin.examplePxfTabTitle"
                    :version-pxf-data="selectedFundingDetailVersion.versionPxfData"
                    :version-pxf-tab-title="fundingDetailsDto.pxfPopin.versionPxfTabTitle"
                    :pxf-legal-mentions-text="fundingDetailsDto.pxfPopin.pxfLegalMentionsText"
                    :illustration="fundingDetailsDto.pxfPopin.imageZen"
                    :financing-block="fundingDetailsDto.pxfPopin.financingBlock"
                    :cgu="fundingDetailsDto.pxfPopin.cguDto"
                    :how-to-benefit-dto="fundingDetailsDto.pxfPopin.howToBenefitDto"
                />
            </template>
        </pxf-cb4x-modal>
    </div>
</template>

<style scoped lang="scss">
@import 'msh_mixins';
@import 'ob1_common';
@import 'ob1_variables';

#filters-modal div.card {
    flex-direction: column;
}
</style>
